import { render, staticRenderFns } from "./PviTable.vue?vue&type=template&id=67425c2d&scoped=true&"
import script from "./PviTable.vue?vue&type=script&lang=js&"
export * from "./PviTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67425c2d",
  null
  
)

export default component.exports